import styled from 'styled-components';
import TextArea from 'components/TextArea';

export const TextAreaDescription = styled(TextArea).attrs({
  id: "descriptionSimple",
  stateName: "description",
  minLength: 10,
  name: "Descrição",
  placeholder: "Detalhe o ocorrido",
  required: true
})`
  flex: 1;
  height: 200px;
  min-height: 200px;
`;
